import { TotemDatePicker } from 'components/TotemDatePicker';
import { DetailList, DetailListRemoveButton } from 'components/DetailsView/DetailList';
import { dateFromString, formatDateAsAnniversary } from 'helpers/dateTimes';

type ClosingDatesRangeForm = {
    start: string | null;
    end: string | null;
    __typename?: 'SiteClosingDatesRange';
};

export const ClosingDates = ({
    closingDatesRanges,
    setClosingDatesRanges,
}: {
    closingDatesRanges: ClosingDatesRangeForm[];
    setClosingDatesRanges: (closingDatesRanges: ClosingDatesRangeForm[]) => void;
}) => {
    function onStartChange(date: Date, index: number) {
        setClosingDatesRanges(
            closingDatesRanges.map((closingDatesRange, closingDatesRangeIndex) => {
                if (closingDatesRangeIndex !== index) {
                    return closingDatesRange;
                }

                return { ...closingDatesRange, start: formatDateAsAnniversary({ dateTime: date }) };
            }),
        );
    }

    function onEndChange(date: Date, index: number) {
        setClosingDatesRanges(
            closingDatesRanges.map((closingDatesRange, closingDatesRangeIndex) => {
                if (closingDatesRangeIndex !== index) {
                    return closingDatesRange;
                }

                return { ...closingDatesRange, end: formatDateAsAnniversary({ dateTime: date }) };
            }),
        );
    }

    function removeRange(index: number) {
        setClosingDatesRanges(
            closingDatesRanges.filter((_, closingDatesRangeIndex) => closingDatesRangeIndex !== index),
        );
    }

    const errors = [] as string[];

    closingDatesRanges.forEach((closingDatesRange, index) => {
        const { start, end } = closingDatesRange;

        if (!start) {
            errors.push(`L'intervalle de fermeture n°${index + 1} n'a pas de date de fermeture`);
        }

        if (!end) {
            errors.push(`L'intervalle de fermeture n°${index + 1} n'a pas de date de réouverture`);
        }

        if (start && end && dateFromString(start) >= dateFromString(end)) {
            errors.push(`L'intervalle de fermeture n°${index + 1} a une date de réouverture avant celle de fermeture`);
        }
    });

    return (
        <>
            {errors.map((error, index) => (
                <div key={index} className="text-sm text-destructive">
                    {error}
                </div>
            ))}
            <DetailList
                label="Dates de fermeture"
                maxHeight="300px"
                onAdd={() =>
                    setClosingDatesRanges([
                        ...closingDatesRanges,
                        { start: null, end: null, __typename: 'SiteClosingDatesRange' },
                    ])
                }
                items={closingDatesRanges.map((closingDatesRange, index) => {
                    const { start: startDate, end: endDate } = closingDatesRange;

                    return (
                        <>
                            <TotemDatePicker
                                label="Fermeture"
                                selected={startDate ? dateFromString(startDate) : null}
                                onChange={(date) => {
                                    if (date) {
                                        onStartChange(date, index);
                                    }
                                }}
                            />
                            <TotemDatePicker
                                label="Réouverture"
                                selected={endDate ? dateFromString(endDate) : null}
                                onChange={(date) => {
                                    if (date) {
                                        onEndChange(date, index);
                                    }
                                }}
                            />
                            <DetailListRemoveButton onClick={() => removeRange(index)} />
                        </>
                    );
                })}
            />
        </>
    );
};
